export const STRINGS = {
  vbLink: "https://virginiabeach.gov/",
  vbgoLink: process.env.REACT_APP_VBGO_URL,
  vbparkfinderLink: process.env.REACT_APP_VBPARKFINDER_URL,
  vbgoNativeLink: "vbgo://",
  vbparkfinderNativeLink: "vbparkfinder://",
  vbparkfinderAppName: "VB Parkfinder",
  seamlessLink: "https://vbforms.seamlessdocs.com/f/591aee3f813a504e82d289d7894aac37",
  moreAppsLink: "https://virginiabeach.gov/connect/mobile-apps",
  bulkPickupLink: "https://vb311.virginiabeach.gov/service-navigation?c__service_code=BULKPKSW",
  streetSweepingLink:
    "https://www.sweepingcorp.com/service-areas/cityofvirginiabeach/#:~:text=You%20can%20contact%20the%20SCA%2cto%20vabeachsweeping%40sweepingcorp.com",
  reportIssueLink: "https://vb311.virginiabeach.gov/service-selection",
  centersLink: "https://pw.virginiabeach.gov/trash-recycling",
  appleAppstoreLink: "https://apps.apple.com/us/app/vb-connect/id890071467",
  googlePlaystoreLink: "https://play.google.com/store/apps/details?id=com.vbgov.vbconnect",
  holidayScheduleLink: "https://pw.virginiabeach.gov/trash-recycling/waste-management-holiday-schedule",
  googleMapLink: "https://www.google.com/maps/search/?api=1&query=",
  connect: "Connect",
  garbageRecyclingNotifications: "Garbage / Recycling Notifications",
  yourAddress: "YOUR ADDRESS",
  streetAddress: "Street Address...",
  findMySchedule: "Look Up Info",
  propertyInfo: "Property Info",
  holidaySchedule: "Holiday Schedule",
  streetSweeping: "STREET SWEEPING",
  reportIssue: "REQUEST SERVICE",
  centers: "TRASH & RECYCLING",
  bulkPickup: "BULK PICKUP",
  noResultsFound: "No results found",
  clearAddress: "Clear Address",
  getAddress: "Get Address",
  errorFetchingAddress: "Error fetching address, location services may be disabled. Please try again.",
  failedToSubscribe: "Failed to subscribe. Please try again.",
  feedbackAndHelp: "Feedback & Help",
  submitFeedback: "Submit Feedback",
  about: "About",
  back: "Back",
  version: `Version: ${process.env.REACT_APP_VERSION} ${
    process.env.REACT_APP_ENV !== "prod"
      ? `(${process.env.REACT_APP_BUILD}) - ${process.env.REACT_APP_ENV.toUpperCase()}`
      : ""
  }`,
  termsOfService: "Terms of Service",
  moreInfo: "More info",
  learnMore: "Learn More",
  viewOurOtherApps: "View our other apps",
  failedToLoadData: "Failed to load data. Please try again later.",
  failedToOpenLink: "Failed to open link. Please try again later.",
  failedToFetchAddressData: "Failed to fetch address data. Please try again later.",
  failedToAddEventToCalendar:
    "Failed to add events to calendar. Please go to Settings and allow VB Connect to access your calendar.",
  notificationPermissionRequired: "Please give VB Connect notification permissions to enable this feature.",
  noPropertyInfoAvailable: "No property information available for this address.",
  invalidPickupType: "Invalid pickup type. Please try again.",
  addressNotFound: "Address not found. Please try a different address.",
  email: "Email",
  text: "Text",
  signup: "SIGN UP",
  ok: "OK",
  cancel: "Cancel",
  emailAddress: "Email Address",
  phoneNumber: "Phone Number",
  emailAddressPlaceholder: "example@domain.com",
  phoneNumberPlaceholder: "XXX-XXX-XXXX",
  subscriptionHeader: "Sign up now and remind yourself the day before at 5pm",
  emailSubscriptionTermsOfService: `By signing up, you consent to receive email notifications regarding garbage and recycling services from the City of Virginia Beach. These alerts will include weekly reminders to help you manage your waste disposal needs effectively.`,
  smsSubscriptionTermsOfService: `By signing up, you consent to receive automated reminder texts from the City of Virginia Beach. Message fequency varies. Message + data rates may apply. Reply STOP to unsubscribe or HELP for more info. View terms/conditions and privacy policy `,
  changeAddressConfirmation: "Are you sure you want to change your address?",
  garbageNotifications: {
    garbagePickup: "Garbage Pickup",
    recyclePickup: "Recycle Pickup",
    garbagePickupAlerts: "Garbage Pick Up Alerts",
    garbagePickupSubheader: "Get notified at 5:00 PM the evening before your pickup day",
    garbagePickupTitle: "Garbage pick up reminder",
    garbagePickupDescription: "Your garbage is scheduled to be picked up tomorrow",
    recyclePickupTitle: "Recycling pick up reminder",
    recyclePickupDescription: "Your recycling is scheduled to be picked up tomorrow",
  },
  socialLinks: {
    facebook: "https://www.facebook.com/CityofVaBeach",
    linkedin: "https://linkedin.com/company/city-of-virginia-beach/",
    twitter: "https://x.com/cityofvabeach",
    instagram: "https://www.instagram.com/cityofvabeach/",
    youtube: "https://www.youtube.com/user/VirginiaBeachTV",
    beintheknow: "https://cloud.mc.virginiabeach.gov/ghbz32hbemp",
  },
  nearbyPlaces: {
    fire: "Nearby Fire Stations",
    police: "Nearby Police Stations",
    libraries: "Nearby Libraries",
    schools: "Zoned Schools",
    parks: "Nearby Parks",
    voting: "My Voting Info",
    default: "Closest Facilities",
  },
  votingInfo: {
    pollingLocation: "Polling Location",
    precinct: "Precinct",
    electionDistrict: "Election District",
    houseDistrict: "House District",
    senateDistrict: "Senate District",
  },
  pushNotificationsSettings: {
    pushSettingsHeader: "Subscribe to Push Notifications",
    newsReleases: "News Releases",
    garbageCollection: "Garbage Collection",
  },
};
